import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import { LocationsService } from '../locations.service';
import { Locations } from '../locations';
import { LocationCollection } from '../../location-collections/location-collections';
import { ActivatedRoute, Router } from '@angular/router';

declare const google: any;

@Component({
    selector: 'app-new-location',
    templateUrl: './new.component.html',
    styleUrls: ['./new.component.scss'],
    standalone: false
})
export class AddLocationComponent implements OnInit {
  @ViewChild('search', { static: false })
  public searchElementRef: ElementRef;

  location: Locations = new Locations();
  locationCollection: LocationCollection;
  errorInSelectedAddress = false;
  options = {
    componentRestrictions: { country: 'us' }
  };

  constructor(
    private locationService: LocationsService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  extractAddresses(addresss) {
    const addressComponent = {};
    addresss.forEach((address) => {
      const keys = address.types;
      if (keys.indexOf('postal_code') !== -1) {
        addressComponent['postal_code'] = address.long_name;
      } else if (keys.indexOf('administrative_area_level_1') !== -1) {
        addressComponent['administrative_area_level_1'] = address.long_name;
      } else if (keys.indexOf('locality') !== -1 || keys.indexOf('neighborhood') !== -1 || keys.indexOf('administrative_area_level_3') !== -1) {
        addressComponent['locality'] = address.long_name;
      } else if (keys.indexOf('street_number') !== -1) {
        addressComponent['street_number'] = address.long_name;
      } else if (keys.indexOf('route') !== -1) {
        addressComponent['route'] = address.long_name;
      }
    });
    return addressComponent;
  }

  ngOnInit() {
    this.route.data.subscribe(data => {
          const locationCollection = data.locationCollection.location_collection;
          this.locationCollection = new LocationCollection();
          this.locationCollection.id = locationCollection.id;
          this.locationCollection.name = locationCollection.name;
        });
  }

  ngAfterViewInit() {
    const input = document.getElementById('address-input');
    const autocomplete = new google.maps.places.Autocomplete(input, {
      types: ['address'],
      componentRestrictions: { country: 'us' }
    });
    autocomplete.addListener('place_changed', () => {
      const place = autocomplete.getPlace();
      this.addressChanged(place);
    });
  }

  addressChanged(place: any) {
    if (place.geometry === undefined || place.geometry === null) {
      this.errorInSelectedAddress = true;
      return;
    }
    const addressComponent = this.extractAddresses(place.address_components);
    const formattedAddressComponents = {
      zipcode: addressComponent['postal_code'],
      state: addressComponent['administrative_area_level_1'],
      city: addressComponent['locality'],
      streetAddress: [addressComponent['street_number'], addressComponent['route']].filter(val => val).join(' ')
    };
    if (!
        (formattedAddressComponents.zipcode && formattedAddressComponents.state && formattedAddressComponents.city)
    ) {
      this.errorInSelectedAddress = true;
    } else {
      this.errorInSelectedAddress = false;
      const lat = String(place.geometry.location.lat());
      const lng = String(place.geometry.location.lng());
      this.location.latitude = parseFloat(lat).toFixed(7);
      this.location.longitude = parseFloat(lng).toFixed(7);
      this.location.state = formattedAddressComponents.state;
      this.location.city = formattedAddressComponents.city;
      this.location.zipcode = formattedAddressComponents.zipcode;
      this.location.street_address = formattedAddressComponents.streetAddress;
      this.location.location_collection_id = this.locationCollection.id;
    }
  }

  addLocation() {
    this.locationService.create(this.location).subscribe(() => {
      this.router.navigate(['/locationCollections', this.locationCollection.id, 'locations']);
    });
  }
}
